import { render, staticRenderFns } from "./SocialsPrompt.vue?vue&type=template&id=7e88907a&scoped=true&"
import script from "./SocialsPrompt.vue?vue&type=script&lang=js&"
export * from "./SocialsPrompt.vue?vue&type=script&lang=js&"
import style0 from "./SocialsPrompt.vue?vue&type=style&index=0&id=7e88907a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e88907a",
  null
  
)

export default component.exports